import { citation, statusLabel, verdictPresentation } from '../../lib/ai/semantics.ts'
import { Badge } from '../primitives/Badge.tsx'
import type { Tone } from '../primitives/Metric.tsx'

/** Selo do veredito: quadrado cheio + palavra, como o de severidade. */
export function VerdictBadge({ verdict, size = 'sm' }: { verdict: string | null; size?: 'sm' | 'lg' }) {
  const p = verdictPresentation(verdict)
  if (p === null) return null
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 border ${p.border} ${p.text} ${
        size === 'lg' ? 'px-2 py-0.5 text-sm' : 'px-1.5 py-px text-micro'
      } font-medium uppercase tracking-label`}
    >
      <span aria-hidden className={`inline-block ${size === 'lg' ? 'size-2' : 'size-1.5'} ${p.fill}`} />
      {p.label}
    </span>
  )
}

const STATUS_TONE: Record<string, Tone> = {
  analysis_failed: 'crit',
  confirmed: 'crit',
  dismissed: 'neutral',
  awaiting_analysis: 'warn',
  triage_only: 'neutral',
  analyzed: 'accent',
}

export function FindingStatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={STATUS_TONE[status] ?? 'neutral'} dashed={status === 'triage_only'}>
      {statusLabel(status)}
    </Badge>
  )
}

/** Um selo por entrada de `cited_as`; lista vazia = estava na janela sem ser citado. */
export function CitationBadges({ citedAs, stacked = false }: { citedAs: readonly string[]; stacked?: boolean }) {
  if (citedAs.length === 0) {
    return <span className="text-micro text-fg-muted">No período analisado, não citado</span>
  }
  return (
    <span className={stacked ? 'inline-flex flex-col items-start gap-1' : 'inline-flex flex-wrap gap-1'}>
      {citedAs.map((value) => {
        const c = citation(value)
        return (
          <Badge key={value} tone={c.kind === 'evidence' ? 'crit' : 'accent'} dot={c.kind === 'evidence'}>
            {c.label}
          </Badge>
        )
      })}
    </span>
  )
}
